const reducerName = '@cityoo-backoffice/territories/countries';

export const RESET = `${reducerName}/RESET`;

export const GET_COUNTRIES_START = `${reducerName}/GET_COUNTRIES_START`;
export const GET_COUNTRIES_SUCCESS = `${reducerName}/GET_COUNTRIES_SUCCESS`;
export const GET_COUNTRIES_FAIL = `${reducerName}/GET_COUNTRIES_FAIL`;
